import React, { Component } from 'react'
import { useLocation } from 'react-router-dom'
import { Button, InputItem, Flex, Toast, Modal } from 'antd-mobile'
import wx from 'weixin-js-sdk'

import { isWX } from '../../utils'
import { getBackupList, backupCheck, backupAdd } from '../../apis'
import NavBarPage from '../../components/NavBarPage'

import './index.css'
import closeIcon from '../../assets/imgs/close_icon_white.png'
import qrcodeImg from '../../assets/imgs/code.png'

// 通过自定义 moneyKeyboardWrapProps 修复虚拟键盘滚动穿透问题
// https://github.com/ant-design/ant-design-mobile/issues/307
// https://github.com/ant-design/ant-design-mobile/issues/163
const isIPhone = new RegExp('\\biPhone\\b|\\biPod\\b', 'i').test(
  window.navigator.userAgent
)
let moneyKeyboardWrapProps
if (isIPhone) {
  moneyKeyboardWrapProps = {
    onTouchStart: (e) => e.preventDefault(),
  }
}

class Battery extends Component {
  constructor(props) {
    super(props)
    this.onScrollEvent = this.onScrollEvent.bind(this)
    this.state = {
      navBarText: '回收电池',
      batteryList: [], //展示输入的电池
      tempInputValue: '', //记录输入的电池
      stockModal: false, //商家库存弹窗
      placeholderValue: '',
      showPlaceholderValue: false,
      page: 1,
      backupList: [], //备用电池列表
      batteryAcount: '', //备用电池总数
      tipsModal: false, //展示新增或回收电池时接口返回的信息
      tips: '', //新增或回收电池时接口返回的信息
      businessInfo: '', //商家信息
    }
  }
  tempList = []
  componentDidMount() {
    let tempNavBar = ''
    if (this.props.location.query) {
      const { pageType, businessId, businessName } = this.props.location.query
      if (pageType === 2) {
        tempNavBar = '回收电池'
      } else {
        tempNavBar = '新增备用电池'
      }
      this.setState({
        navBarText: tempNavBar,
        businessInfo: { businessId, businessName, pageType },
      })
    } else {
      let storageBusinessInfo = JSON.parse(localStorage.getItem('businessInfo'))
      if (!storageBusinessInfo) return

      if (storageBusinessInfo.pageType === 2) {
        tempNavBar = '回收电池'
      } else {
        tempNavBar = '新增备用电池'
      }
      this.setState({
        navBarText: tempNavBar,
        businessInfo: storageBusinessInfo,
      })
    }
  }

  // 获取备用电池列表
  fetchBackupList(merge = true) {
    console.log('---获取列表')
    const { page, businessInfo } = this.state
    getBackupList(businessInfo.businessId, page, 1)
      .then((res) => {
        const data = res.list
        if (data.length === 0 && this.state.page > 1) {
          this.setState({
            page: this.state.page - 1,
          })
        }
        let tempRes = []
        if (merge) {
          tempRes = [...this.state.backupList, ...data]
        } else {
          tempRes = data
        }
        this.setState({
          backupList: tempRes,
          stockModal: true,
          batteryAcount: res.totalCount,
        })
      })
      .catch((err) => {
        console.log('获取备用电池列表err:', err)
      })
  }

  // 新增/回收备用电池
  handleAddOrBackup() {
    const { pageType, businessId } = this.props.location.query
    let batteryData = this.state.batteryList.map((v) => v).join(',')
    this.backUpCheck(pageType, businessId, batteryData).then((res) => {
      if (res.hasRepeat) {
        this.setState({
          tips: res.tips,
          tipsModal: true,
        })
      } else {
        this.addBattery(pageType, businessId, batteryData)
      }
    })
  }

  addBattery(pageType, businessId, batteryData) {
    backupAdd(pageType, businessId, batteryData).then((res) => {
      let toast = `${pageType === 1 ? '新增' : '回收'}备用电池成功`
      Toast.info(toast)
      this.tempList = []
      this.setState({
        batteryList: [],
      })
    })
  }

  // 校验新增/回收备用电池
  backUpCheck(pageType, businessId, batteryData) {
    return new Promise((resolve) => {
      backupCheck(pageType, businessId, batteryData)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          console.log('校验接口err:', err)
        })
    })
  }

  handleComfirmAdd() {
    const { pageType, businessId } = this.props.location.query
    let batteryData = this.state.batteryList.map((v) => v).join(',')
    this.addBattery(pageType, businessId, batteryData)
    this.setState({
      tipsModal: false,
    })
  }

  //滑动加载
  onScrollEvent() {
    if (
      this.scrollRef.scrollTop + this.scrollRef.clientHeight ===
      this.scrollRef.scrollHeight
    ) {
      console.info('到底了！')
      this.setState(
        {
          page: this.state.page + 1,
        },
        () => {
          this.fetchBackupList()
        }
      )
    }
  }

  // 扫码输入电池编号
  openPopQrcode() {
    if (this.state.batteryList.length === 10) {
      Toast.info('最多可录入10个充电宝')
    } else {
      this.qrcode().then((result) => {
        console.log('扫码录入电池----', result, result.split(',')[1])
        if (result.split(',')[1]) {
          this.tempList.push(result.split(',')[1])
          this.tempList = [...new Set(this.tempList)]
          this.setState({
            batteryList: this.tempList,
          })
        }
      })
    }
  }
  // 开启微信扫码
  qrcode() {
    if (isWX()) {
      return new Promise((resolve, reject) => {
        wx.scanQRCode({
          needResult: 1,
          scanType: ['qrCode', 'barCode'],
          success: (res) => {
            resolve(res.resultStr)
          },
        })
      })
    } else {
      Toast.info('请使用微信浏览器打开\nWeChatで開いてください')
      return Promise.reject()
    }
  }

  //输入电池编号
  handleInput() {
    if (this.state.batteryList.length === 10) {
      Toast.info('最多可录入10个充电宝')
    } else {
      this.inputRef.focus()
    }
  }

  inputChange(value) {
    const { tempInputValue } = this.state
    let tempValue = ''
    setTimeout(() => {
      if (tempInputValue) {
        tempValue = value.split(tempInputValue)[1]
          ? value.split(tempInputValue)[1]
          : tempInputValue
      } else {
        tempValue = value
      }
      this.setState({
        placeholderValue: tempValue,
      })
    }, 50)
  }

  // 点击键盘的确定按钮
  inputBatteryNo(e) {
    const { tempInputValue } = this.state
    if (tempInputValue) {
      console.log(
        '截取:',
        this.state.tempInputValue,
        e.split(this.state.tempInputValue)[1]
      )
      this.tempList.push(e.split(this.state.tempInputValue)[1])
    } else {
      this.tempList.push(e)
    }
    this.tempList = [...new Set(this.tempList)]
    this.setState({
      batteryList: this.tempList.filter((d) => d),
      tempInputValue: e,
      showPlaceholderValue: false,
    })
    setTimeout(() => {
      this.setState({
        placeholderValue: '',
      })
    }, 100)
  }

  // 删除输入的选项
  handleDelete(item) {
    const { batteryList } = this.state
    let temp = batteryList
    temp.splice(
      temp.findIndex((v) => v === item),
      1
    )

    this.setState({
      batteryList: temp,
    })
    this.tempList = temp
  }

  // 关闭弹窗还原状态
  afterModalClose() {
    this.setState({
      page: 1,
    })
  }

  render() {
    const {
      navBarText,
      batteryAcount,
      batteryList,
      stockModal,
      backupList,
      placeholderValue,
      showPlaceholderValue,
      tipsModal,
      tips,
      businessInfo,
    } = this.state
    // const { businessName } = this.props.location.query

    // console.log("batteryList:",backupList)
    // const backupList = [{powerNo:"10029302",creator:"lockman",createTime:"2021-01-20 15:46:34"},{powerNo:"10029302",creator:"lockman",createTime:"2021-01-20 15:46:34"},
    // {powerNo:"10029302",creator:"lockman",createTime:"2021-01-20 15:46:34"},
    // {powerNo:"10029302",creator:"lockman",createTime:"2021-01-20 15:46:34"},
    // {powerNo:"10029302",creator:"lockman",createTime:"2021-01-20 15:46:34"},
    // {powerNo:"10029302",creator:"lockman",createTime:"2021-01-20 15:46:34"},
    // {powerNo:"10029302",creator:"lockman",createTime:"2021-01-20 15:46:34"},
    // {powerNo:"10029302",creator:"lockman",createTime:"2021-01-20 15:46:34"},
    // {powerNo:"10029302",creator:"lockman",createTime:"2021-01-20 15:46:34"},
    // {powerNo:"10029302",creator:"lockman",createTime:"2021-01-20 15:46:34"},
    // {powerNo:"10029302",creator:"lockman",createTime:"2021-01-20 15:46:34"}]
    return (
      <div className="container">
        <NavBarPage title={navBarText}>
          <div className="flex_bet pad15 business_info">
            <div>当前商家</div>
            <div>{businessInfo.businessName}</div>
          </div>
          <div
            className="flex_bet pad15 battery_stock"
            onClick={() => this.fetchBackupList(false)}
          >
            <div>备用库存</div>
            <div>{`查看 >`}</div>
          </div>
          <div className="flex_bet pad15">
            <div>录入电池</div>
            <div onClick={this.openPopQrcode.bind(this)} className="qrcode_box">
              <img className="icon_qrcode" src={qrcodeImg} alt="扫码" />
              扫码
            </div>
          </div>
          <div className="battery_list" onClick={() => this.handleInput()}>
            <Flex wrap="wrap">
              {batteryList.length > 0 ? (
                <Flex wrap="wrap">
                  {batteryList.map((v, i) => {
                    return (
                      <button
                        className="battery_list_item"
                        key={`battery-${i}`}
                        onClick={this.handleDelete.bind(this, v)}
                      >
                        <text>{v}</text>
                        <img className="closeIcon" src={closeIcon} alt="" />
                      </button>
                    )
                  })}
                  {showPlaceholderValue && (
                    <div
                      className={
                        placeholderValue
                          ? 'battery_list_placeholder'
                          : 'battery_list_placeholder color_a7'
                      }
                    >
                      {placeholderValue}
                    </div>
                  )}
                </Flex>
              ) : (
                <div
                  className={
                    placeholderValue
                      ? 'battery_list_placeholder'
                      : 'battery_list_placeholder color_a7'
                  }
                >
                  {placeholderValue
                    ? placeholderValue
                    : '扫码充电宝二维码或输入充电宝编号，点击键盘的确定按钮'}
                </div>
              )}
            </Flex>
            <div className="battery_list_all">{batteryList.length} / 10</div>
          </div>
          <div className="keybord_box">
            <InputItem
              type="money"
              placeholder={
                batteryList.length > 0
                  ? ''
                  : '扫码充电宝二维码或输入充电宝编号，点击键盘的完成按钮'
              }
              ref={(el) => (this.inputRef = el)}
              moneyKeyboardAlign="left"
              onVirtualKeyboardConfirm={this.inputBatteryNo.bind(this)}
              clear
              moneyKeyboardWrapProps={moneyKeyboardWrapProps}
              disabledKeys={['.']}
              onChange={(v) => this.inputChange(v)}
              onFocus={() => {
                this.setState({ showPlaceholderValue: true })
              }}
            ></InputItem>
          </div>

          <Button
            className="comfirm_btn"
            disabled={batteryList.length === 0}
            onClick={this.handleAddOrBackup.bind(this)}
          >
            确定
          </Button>
          <Modal
            className="battery_modal"
            visible={stockModal}
            transparent
            closable={true}
            maskClosable={true}
            onClose={() => {
              this.setState({ stockModal: false })
            }}
            title="商家备用库存"
            wrapProps={{ onTouchStart: this.onWrapTouchStart }}
            afterClose={() => this.afterModalClose()}
          >
            <div className="stock_modal_body">
              <div
                className="stock_modal_content"
                ref={(c) => {
                  this.scrollRef = c
                }}
                onScrollCapture={() => this.onScrollEvent()}
              >
                <div className="title">
                  <div className="battery_no">电池编号</div>
                  <div className="account_box">录入账号</div>
                  <div className="time_box">录入时间</div>
                </div>
                <div className="stock_list">
                  {backupList.map((item, index) => {
                    return (
                      <div
                        key={`stock_list${index}`}
                        className="stock_list_item"
                      >
                        <div className="battery_no">{item.powerNo}</div>
                        <div className="account_box">{item.creator}</div>
                        <div className="time_box">{item.createTime}</div>
                      </div>
                    )
                  })}
                </div>
              </div>
              <div className="statistic_box">
                当前备用电池数：{batteryAcount}{' '}
              </div>
            </div>
          </Modal>

          <Modal
            className="battery_modal"
            visible={tipsModal}
            transparent
            closable={true}
            maskClosable={false}
            onClose={() => {
              this.setState({ tipsModal: false })
            }}
            title="提示"
            wrapProps={{ onTouchStart: this.onWrapTouchStart }}
          >
            <div className="tips_body">{tips} </div>
            <button
              className="confirm_btn"
              onClick={() => this.handleComfirmAdd()}
            >
              {' '}
              {businessInfo.pageType === 2 ? '确认回收' : '确认添加'}{' '}
            </button>
          </Modal>
        </NavBarPage>
      </div>
    )
  }
}
export default function BatteryPage() {
  const location = useLocation()
  return <Battery location={{ query: location.state }} />
}
